export const aboutFeatures = [
  { icon: "ri-shield-check-line", title: "먹튀검증 시스템", desc: "11가지 핵심 지표 기반의 철저한 검증 프로세스로 안전한 사이트만을 추천합니다" },
  { icon: "ri-group-line", title: "활발한 커뮤니티", desc: "10만 명 이상의 회원이 실시간으로 정보를 공유하고 소통하는 커뮤니티 공간을 제공합니다" },
  { icon: "ri-bar-chart-box-line", title: "스포츠 분석", desc: "축구, 야구, 농구, 배구 등 다양한 종목의 전문 분석 정보를 실시간으로 제공합니다" },
  { icon: "ri-customer-service-2-line", title: "24시간 고객지원", desc: "실시간 채팅과 전화 상담을 통해 언제든지 문의하실 수 있습니다" },
  { icon: "ri-notification-3-line", title: "실시간 알림", desc: "중요 공지사항과 신규 검증 정보를 가장 빠르게 전달해 드립니다" },
  { icon: "ri-global-line", title: "투명한 정보 공개", desc: "모든 검증 결과와 통계 데이터를 투명하게 공개하여 신뢰를 구축합니다" },
];

export const teamMembers = [
  { name: "김검증", role: "검증팀 리더", desc: "10년 이상의 사이트 검증 경력을 보유한 베테랑 검증 전문가입니다", avatarSeq: "team-01" },
  { name: "이분석", role: "스포츠 분석가", desc: "국내외 스포츠 데이터를 기반으로 한 정밀 분석을 담당합니다", avatarSeq: "team-02" },
  { name: "박안전", role: "보안 전문가", desc: "사이트 보안 취약점 분석 및 안전성 평가를 담당합니다", avatarSeq: "team-03" },
  { name: "최고객", role: "고객지원 매니저", desc: "신속하고 정확한 고객 응대로 회원 만족도를 책임집니다", avatarSeq: "team-04" },
];

export const milestones = [
  { year: "2024", title: "월드컵티비 출범", desc: "스포츠 정보 커뮤니티로 첫 시작" },
  { year: "2025", title: "먹튀검증 시스템 도입", desc: "자체 검증 알고리즘 개발 및 서비스 확장" },
  { year: "2025", title: "회원 5만 명 돌파", desc: "신뢰 기반의 빠른 성장" },
  { year: "2026", title: "시즌2 리뉴얼 오픈", desc: "새로운 디자인과 강화된 기능으로 서비스 대폭 개선" },
];